import axios from 'axios'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.getclipara.com' : 'http://localhost:8080'
axios.defaults.withCredentials = true

export default axios
